import React from 'react'
import { motion } from 'framer-motion'
import { fadeIn, textVariant } from '../../utility/motion'
import { styles } from '../../styles'
import SectionWrapper from '../HOC/SectionWrapper'

const About = () => {
  return (
    <section className='py-10'>
      <motion.div
        variants={textVariant()}
      >
        <p className={styles.sectionSubText}>Introduction</p>
        <h2 className={styles.sectionHeadText}>About Us.</h2>
      </motion.div>

      <motion.p
        variants={fadeIn('', '', 0.1, 1)}
        className='mt-4 text-secondary text-[17px] max-w-3xl leading-[30px]'
      >
        We are a video game development company dedicated to crafting
        immersive gaming experiences. Our games specialize in delivering rich
        narratives, captivating gameplay, and high-quality graphics. We aim to
        provide players with unforgettable adventures, pushing the boundaries
        of creativity and innovation. By utilizing state-of-the-art game
        development tools and techniques, we empower gamers to dive into
        unique worlds, face thrilling challenges, and engage in epic journeys
        in the vast universe of gaming.
      </motion.p>
    </section>
  )
}

export default SectionWrapper(About, 'about')
